'use client'

import { useSignInVkMutation } from '@/shared/api-rtk'
import { useGetCountProductsQuery } from '@/shared/api-rtk/api-list/cartApi'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import { useEffect, useLayoutEffect } from 'react'
import { redirect } from 'next/navigation'

export const VkAuthEndpoint = () => {
    const [signInVk] = useSignInVkMutation()

    const { userAuth: isAuth, setUser, userInfo } = useGetIsAuthUser()
    const { refetch: refetchCountCart } = useGetCountProductsQuery()

    //check auth
    const navigate = (path) => redirect(path)
    useEffect(() => {
        if (isAuth) {
            navigate('/my-account')
        }
    }, [isAuth])

    useLayoutEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const payload = JSON.parse(urlParams.get('payload'))
        if (payload) {
            signInVk(payload)
                .unwrap()
                .then((res) => {
                    if (res.error) {
                        TOAST_ERROR(res.error)
                        return
                    }
                    if (res.result === 'success') {
                        TOAST_SUCCESS('Вы успешно вошли!')
                        //Назначаем пользователя при успешной регистрации в стейт
                        setUser(res.data)
                        refetchCountCart()
                    }
                })
                .catch((err) => {
                    TOAST_ERROR('Ошибка аунтефикации, попробуйте позже')
                })
        }
    }, [])

    return <div>vk auth</div>
}
